import { useEffect,useRef,useState} from "react";
import WebService from "../../Services/WebService";
import WebUrl from "../../Services/WebUrl";

function AddCategory() {
  
  const[msg,setMsg] = useState()
  var [list,setList] = useState([])

  var itemName = useRef()
  var serviceTypeId = useRef()
  var description = useRef()
  var price = useRef()
  
  // var veeru_name = useRef()

 
  var addCategory = async (event)=>{
    event.preventDefault()
    
    var itemName = itemName.current.value;
    var serviceTypeId = serviceTypeId.current.value;
    var description = description.current.value;
    var price = price.current.value;
    
    // var veeruName = veeru_name.current.value;

  //  console.log(catName)
   var obj = {itemName:itemName,serviceTypeId:serviceTypeId,description:description,price:price}
   console.log(obj)
   setList([...list,obj])
    var result =  await WebService.postAPI(WebUrl.add_category,obj);
   // console.log(result.data.status)
     if(result.data.status)
     {
        setMsg("Category Added...");
     }
  }


  useEffect(()=>{
     loadData()
  },[])

  var loadData =async ()=>{
      var cat_data = await WebService.getAPI(WebUrl.load_category);
    //  console.log(cat_data) 
     setList(cat_data.data.data)
  }


  return<main id="main" className="main">
   <section className="section">
    <div className="row">
      <div className="col-lg-12">

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Add  Service Category : </h5>

            {/* General Form Elements */}
            <form onSubmit={addCategory}>
              <div className="row mb-3">
                <label for="inputText"  className="col-sm-2 col-form-label">CategoryName</label>
                <div className="col-sm-10">
                  <input type="text" ref={itemName} placeholder="CategoryName " className="form-control"/>
                </div>
              </div>

              <div className="row mb-3">
                <label for="inputText"  className="col-sm-2 col-form-label">ServiceTypeId</label>
                <div className="col-sm-10">
                  <input type="text" ref={serviceTypeId} placeholder="ServiceTypeId " className="form-control"/>
                </div>
              </div>

              <div class="control-group">
                                <textarea class="form-control p-2" ref={description} rows="3" id="message" placeholder="Description" required="required" data-validation-required-message="Description"></textarea>
                                <p class="help-block text-danger"></p>
              </div>
                            
              <div className="row mb-3">
                <label for="inputText"  className="col-sm-2 col-form-label">Price</label>
                <div className="col-sm-5">
                  <input type="number" ref={price} placeholder="Price" className="form-control"/>
                </div>
              </div>
              
              <div className="row mb-3">
                <label for="inputText"  className="col-sm-2 col-form-label">Image</label>
                <div className="col-sm-5">
                  <input type="file" placeholder="File" className="form-control"/>
                </div>
              </div>
      
              <div className="row mb-3">
                <div className="col-sm-10">
                  <button type="submit" className="btn btn-primary">Submit Category</button>
                </div>
              </div>
            </form>{/* End General Form Elements */}
           
          <h1>{msg}</h1>
           
          </div>
        </div>
        <h1 style={{textAlign:'center'}}> Service Category List : </h1>
        <br/><br/>
        <div className="container">
            <table className="table table-bordered table-hover table-striped" style={{ border: '4px solid black' }}>
              <tr>
                 <th>S.No</th>
                 <th>Category Name</th>
                 <th>Service Type Id</th>
                 <th>Description</th>
                 <th>Price</th>
                 {/* <th>Image</th> */}
                 <th>Operation</th> 
              </tr>
              <tbody>
              {list.map((res,index)=>{
                return<tr>
                  <td>{index+1}</td>
                  <td>{res.itemName}</td>
                  <td>{res.serviceTypeId}</td>
                  <td>{res.description}</td>
                  <td>{res.price}</td>
                  {/* <td>{res.itemImage}</td> */}
                  <button style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', padding: '3px 5px', cursor: 'pointer' }}>Update</button> 
                <button style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', padding: '3px 5px', cursor: 'pointer' }}>Delete</button>
                </tr>
              })}
              </tbody>

            </table>
            </div>
      </div>

      
    </div>
  </section>

</main>
}

export default AddCategory;
